<template>
  <v-flex>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="900"
      class="message_dialog_no_overflowUserGroupDialog"
    >
      <v-flex class="dialogActivitiesSelecterUserGroupDialog">
        <v-layout row class="ml-2 pt-4 pb-2">
          <v-icon
            class="ml-4"
            :style="`color: ${$vuetify.theme.primary}`"
            large
          >format_list_bulleted</v-icon>
          <h1 :style="`color: ${$vuetify.theme.primary}`" class="ml-3">{{$translate('PART_OF')}}</h1>
        </v-layout>
        <v-layout align-center justify-center row>
          <v-btn
            :disabled="userRolesSelectedFromAvailableList.length === 0"
            round
            color="primary"
            class="text-capitalize"
            @click="addToSelected"
          >
            <v-icon large>arrow_forward</v-icon>
          </v-btn>
          <v-btn
            :disabled="userRolesSelectedFromRegisteredList.length == 0"
            round
            color="secondary"
            class="text-capitalize"
            @click="removeFromSelected"
          >
            <v-icon large>arrow_back</v-icon>
          </v-btn>
        </v-layout>
        <v-layout align-center row class="pt-2 pl-4 ml-4">
          <v-flex xs6>
            <v-layout column>
              <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('UR_FOR_USER')}}</h3>
              <div class="elevation-1 cardEventsUserGroupDialog">
                <v-list>
                  <v-list-tile v-for="(item, index) in userRolesAvailableForUser" :key="index" @click="">
                    <v-list-tile-action>
                      <v-checkbox
                        class="ml-2 mt-4"
                        v-model="item.Selected"
                        @change="cbLeftClicked(index)"
                      ></v-checkbox>
                    </v-list-tile-action>
                      
                    <v-list-tile-content
                      class="listOutlineSubUserGroupDialog"
                      @click="addElementToAvailable(index)"
                    >
                      <v-list-tile-title>{{item.Description}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.PartnerName}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
              <v-checkbox
                class="mt-1"
                label="Select all"
                v-model="selectedAllRegisteredUserRoles"
                @change="checkAllAvailableUserGroup"
              ></v-checkbox>
            </v-layout>
          </v-flex>

          <v-flex xs6>
            <v-layout column>
              <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('SELECTED_UG_FOR_USER')}}</h3>
              <v-flex class="elevation-1 cardEventsUserGroupDialog">
                <v-list>
                  <v-list-tile v-for="(item, index) in userRolesToBeSaved" :key="index" @click="">
                    <v-list-tile-action>
                      <v-checkbox
                        class="ml-2 mt-4"
                        v-model="item.Selected"
                        @change="cbRightClicked(index)"
                      ></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content
                      class="listOutlineSubUserGroupDialog"
                      @click="addElementToSelected(index)"
                    >
                      <v-list-tile-title>{{item.Description}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.PartnerName}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-checkbox
                class="mt-1"
                label="Select all"
                v-model="selectedAllAvailableUserRoles"
                @change="checkAllSelectedUserGroup"
              ></v-checkbox>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="mr-4" align-end justify-end row>
          <v-btn
            round
            color="secondary"
            class="text-capitalize"
            @click="cancelDialog"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            round
            color="primary"
            class="text-capitalize"
            @click="saveChildren"
          >{{$translate('SAVE')}}</v-btn>
        </v-layout>
      </v-flex>
    </v-dialog>

    <v-dialog v-model="doubleUserGroupDialog" persistent max-width="390">
      <v-card class="confirmLoadingDialog">
        <v-layout column justify-center align-start>
          <v-card-title class="headline">Error</v-card-title>
          <v-card-text>
            <p>{{$translate('DOUBLEUSERGROUP_ERROR')}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn
                round
                color="primary"
                @click="doubleUserGroupDialog = false"
              >{{ $translate('CANCEL') }}</v-btn>
            </v-flex>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { ui_helpers } from "../shared/ui_helpers.js";
import * as dssRequest from "../api/dssRequest";
import BaseComponent from "./base/BaseComponent";
import BaseObject from "../objects/BaseObject";
import { setTimeout } from "timers";
import { store } from "../store";
export default {
  name: "UserGroupDialog",
  extends: BaseComponent,
  mixins: [ui_helpers],
  props: {
    showDialog: Boolean,
    id: String
  },
  computed : {
    userGroupId() {
      if (this.PartnerId != undefined && Number(this.PartnerId) > -1) {
        return this.currentAccountId + "_UG_" + this.PartnerId;
      } else {
        return this.currentAccountId;
      }
    },
    userRolesFromUserGroup() {
      let tmpUerRoles = this.$store.getters.getUserRolesFromUserGroup;
      tmpUerRoles.forEach(
        userRole => userRole.Selected = false
      );
      return tmpUerRoles;
    }
  },
  watch: {
    showDialog: function(newV, oldV) {
      if (newV === true) {
        this.getUserRolesFromUser();
      }
    }
  },
  data() {
    return {
      doubleUserGroupDialog: false,
      selectedAllAvailableUserRoles: false,
      selectedAllRegisteredUserRoles: false,
      userRolesSelectedFromAvailableList: [],
      userRolesSelectedFromRegisteredList: [],
      userRolesAvailableForUser: [],
      userRolesToBeSaved: []
    };
  },
  methods: {
    cbLeftClicked(index) {
      // Called when the check box in the available user role list is clicked on
      // Either remove or add selected user role to the list
      this.updateLeftSelection(index);
    },
    addElementToAvailable(index) {
      this.userRolesAvailableForUser[index].Selected = !this.userRolesAvailableForUser[index].Selected;
      this.updateLeftSelection(index);
    },
    updateLeftSelection(index) {
      const i = this.userRolesSelectedFromAvailableList.findIndex(
        userRole => userRole.UserRoleId === this.userRolesAvailableForUser[index].UserRoleId
      );
      if(i > -1) {
        this.userRolesSelectedFromAvailableList.splice(i, 1);
      } else {
        this.userRolesSelectedFromAvailableList.push(this.userRolesAvailableForUser[index]);
      }
    },
    cbRightClicked(index) {
      // Called when the check box in the personal user role list is clicked on
      // Either remove or add selected user role to the list
      this.updateRightSelection(index);
    },
    addElementToSelected(index) {
      this.userRolesToBeSaved[index].Selected = !this.userRolesToBeSaved[index].Selected;
      this.updateRightSelection(index);
    },
    updateRightSelection(index) {
      const i = this.userRolesSelectedFromRegisteredList.findIndex(
        userRole => userRole.UserRoleId === this.userRolesToBeSaved[index].UserRoleId
      );
      if(i > -1) {
        this.userRolesSelectedFromRegisteredList.splice(i, 1);
      } else {
        this.userRolesSelectedFromRegisteredList.push(this.userRolesToBeSaved[index]);
      }
    },
    getUserRolesFromUser() {
      let payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call [getUserRoles] on User [%s] in component [UserGroupDialog] succeeded",
            this.id,
            response
          );
          this.userRolesToBeSaved = [];
          if(response.data.hasOwnProperty("UserRoles") && response.data.UserRoles !== undefined) {
            this.userRolesToBeSaved = response.data.UserRoles;

            this.getAvailableUserRoles();
          }
        },
        error => {
          console.log(
            "The call [getUserRoles] on User [%s] in component [UserGroupDialog] failed",
            this.id,
            error
          );
        },
        "getUserRoles",
        this.id,
        payload
      );
    },
    getAvailableUserRoles() {
      // Filter out user roles already selected by user
      this.userRolesAvailableForUser = this.userRolesFromUserGroup;

      this.userRolesToBeSaved.forEach(
        userRoleOfUser => {
          userRoleOfUser.Selected = false;
          const i = this.userRolesAvailableForUser.findIndex(
            userRoleOfUserGroup => userRoleOfUser.UserRoleId === userRoleOfUserGroup.UserRoleId
          );

          if(i > -1) {
            this.userRolesAvailableForUser.splice(i, 1);
          }
        }
      );
    },
    checkAllAvailableUserGroup() {
      this.userRolesSelectedFromAvailableList = [];

      if (this.selectedAllRegisteredUserRoles) {
        this.userRolesAvailableForUser.forEach(e => {
          e.Selected = true;
          this.userRolesSelectedFromAvailableList.push(e);
        });
      } else {
        this.userRolesAvailableForUser.forEach(
          e => e.Selected = false
        );
      }
    },
    checkAllSelectedUserGroup() {
      this.userRolesSelectedFromRegisteredList = [];

      if (this.selectedAllAvailableUserRoles) {
        this.userRolesToBeSaved.forEach(e => {
          if (e.Description != "Member") {
            e.Selected = true;
            this.userRolesSelectedFromRegisteredList.push(e);
          }
        });
      } else {
        this.userRolesToBeSaved.forEach(
          e => e.Selected = false
        );
      }
    },
    addToSelected() {
      this.userRolesSelectedFromAvailableList.forEach(e => {
        e.Selected = false;
        this.userRolesToBeSaved.push(e);
        const index = this.userRolesAvailableForUser.findIndex(
          i => i.UserRoleId == e.UserRoleId
        );
        this.userRolesAvailableForUser.splice(index, 1);
      });
      this.userRolesSelectedFromAvailableList = [];
      this.selectedAllAvailableUserRoles = false;
      this.selectedAllRegisteredUserRoles = false;
    },
    removeFromSelected() {
      this.userRolesSelectedFromRegisteredList.forEach(e => {
        e.Selected = false;
        this.userRolesAvailableForUser.push(e);
        const index = this.userRolesToBeSaved.findIndex(
          i => i.UserRoleId == e.UserRoleId
        );
        this.userRolesToBeSaved.splice(index, 1);
      });
      this.userRolesSelectedFromRegisteredList = [];
      this.selectedAllAvailableUserRoles = false;
      this.selectedAllRegisteredUserRoles = false;
    },
    cancelDialog() {
      this.resetDialog();
      this.$emit("signalFromComponent", { closeDialog: true });
    },
    resetDialog() {
      this.userRolesAvailableForUser = [];
      this.userRolesToBeSaved = [];
      this.userRolesSelectedFromRegisteredList = [];
      this.userRolesSelectedFromAvailableList = [];
      this.selectedAllAvailableUserRoles = false;
      this.selectedAllRegisteredUserRoles = false;
    },
    saveChildren() {
      const payload = {
        UserRoles: []
      };
      this.userRolesToBeSaved.forEach(e => {
        payload.UserRoles.push(e.UserRoleId);
      });

      dssRequest.doRequest(
        response => {
          console.log(
            "The call [saveUserRoles] on User [%s] in component [UserGroupDialog] succeeded",
            this.id,
            response
          );
          this.$emit("signalFromComponent", {
            closeDialog: true,
            reload: true
          });
          setTimeout(() => {
            this.resetDialog();
          }, 200);
        },
        error => {
          console.log(
            "The call [saveUserRoles] on User [%s] in component [UserGroupDialog] failed",
            this.id,
            error
          );
          if (
            error.hasOwnProperty("errorMsg") &&
            error.errorMsg.includes("E_OB_040")
          ) {
            this.doubleUserGroupDialog = true;
          }
        },
        "saveUserRoles",
        this.id,
        payload
      );
    }
  }
};
</script>

<style>
.dialogActivitiesSelecterUserGroupDialog {
  background-color: #ffffff;
  border-radius: 1em;
}

.message_dialog_no_overflowUserGroupDialog {
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: 200px;
}

.listOutlineUserGroupDialog {
  margin-top: 1em;
  /* margin-left: 2.6em; */
}

.listOutlineSubUserGroupDialog {
  border-bottom: 1px solid black;
  text-overflow: ellipsis;
  /* margin-left: -0.5em;
  margin-right: -0.5em; */
}

.cardEventsUserGroupDialog {
  /* margin-right: 1em; */
  border: 1.5px solid black;
  min-height: 30em;
  max-height: 30em;
  max-width: 20em !important;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
